import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { submitBrokerConditionCategory } from 'services/apis/conditions'
import { svgLoading } from 'stories/assets'
import { Button } from 'stories/components'
import { InputConvert, InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { uwCategoryInputs } from '../constant'
import type { IBrokerConditionCategory } from './types'

export function BrokerConditionCateogryDetails(props: {
  defaults: IBrokerConditionCategory | null
  lastUpdatedAt: number
  onBack: Function
  onComplete: Function
}) {
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState<Record<string, any>>({})
  const { defaults = null, lastUpdatedAt } = props

  useEffect(() => {
    if (!defaults) {
      setInputs(uwCategoryInputs())
      return
    }
    const newStats = cloneDeep(uwCategoryInputs()) as Record<string, any>
    for (const key in newStats) {
      newStats[key].value = (defaults as any)[key]
    }
    setInputs(newStats)
  }, [defaults, lastUpdatedAt])

  const onBack = () => {
    props.onBack()
  }

  const onChange = (key: string, value: string) => {
    let newInputs = cloneDeep(inputs)
    newInputs[key].value = InputConvert(newInputs[key], value)
    newInputs[key].error = ''
    setInputs(newInputs)
  }

  const onSubmit = () => {
    let hasError = false
    const newStats = cloneDeep(inputs)
    const data: Record<string, any> = {}
    for (const key in newStats) {
      const { value, disabled = false } = newStats[key]
      let error = InputValidate(newStats[key])
      newStats[key].error = error
      if (error.length > 0) hasError = true
      if (!disabled && value !== undefined) data[key] = value
    }

    if (hasError) {
      setInputs(newStats)
      return
    }

    setLoading(true)
    const id = defaults ? defaults.id : 0
    submitBrokerConditionCategory(id, data)
      .then(() => {
        if (id == 0) toast('New category is added.', { type: 'success' })
        else toast(`Category is updated.`, { type: 'success' })
        props.onComplete()
        onBack()
      })
      .catch(() => setLoading(false))
  }

  return (
    <div className="category-container">
      <h2 className="text-2xl font-bold flex items-center mb-3">
        Loan Setup Condition Categories - {!defaults ? 'Add' : `Update`}
        {isLoading && (
          <span className="ml-3">
            <img src={svgLoading} className="inline w-6 h-6 text-white animate-spin" />
          </span>
        )}
      </h2>
      <Button link onClick={onBack}>
        <div className="flex text-shade-blue items-center">
          <ArrowLeftIcon className="w-4 h-4 mr-1" /> <p>Return to Loan Setup Condition Categories</p>
        </div>
      </Button>

      <div className="grid gap-4 md:grid-cols-2 grid-cols-1 mb-3">
        {Object.keys(inputs).map((key, index) => {
          let input = inputs[key]
          return (
            <div className={`input col-span-${input.span}`} key={index}>
              <RenderInput input={input} Key={key} onChange={onChange} />
            </div>
          )
        })}
      </div>
      <div className="block text-center">
        <Button onClick={onSubmit} className="px-10" loading={isLoading}>
          <>{defaults ? 'Update' : 'Add'} Category</>
        </Button>
      </div>
    </div>
  )
}
